var toString = require('./toString');

module.exports = function isArguments(obj){return toString.call(obj) == '[object Arguments]';};


/*****************
 ** WEBPACK FOOTER
 ** ./lib/isArguments.js
 ** module id = 10
 ** module chunks = 0
 **/